import { NavLink } from 'react-router-dom'
import { RefreshCw } from 'lucide-react'
import { useMenuStore } from '@/store/useMenuStore.ts'
import { useProjectStageStore } from '@/components/common/menu/lib/store/useProjectStageStore.tsx'
import { Tip } from '@/components/common/tip/Tip.tsx'
import { cn } from '@/lib/utils.ts'
import Span from '@/components/common/textElements/Span.tsx'
import { useAnimateQueueCount } from '@/components/common/menu/lib/hooks/useAnimateQueueCount.ts'

export default function NavigationMobileCountBtn() {
  const closeMobileMenu = useMenuStore(state => state.closeMobileMenu)
  const stageIri = useProjectStageStore(state => state.iri)
  const { isAnimating, queueCount } = useAnimateQueueCount()

  if (queueCount === 0) return null

  return (
    <NavLink
      onClick={closeMobileMenu}
      to={`${stageIri}/sync-queue`}
      className={`flex h-full w-14 items-center pl-2`}
    >
      <div className={`relative flex w-fit content-center py-2`}>
        <Tip content={`W kolejce znajdują się elementy oczekujące na wysłanie.   `}>
          <RefreshCw
            className={cn(
              'd size-4 transition-colors',
              isAnimating && 'text-destructive',
              isAnimating && 'animate-[spin_1500ms_linear_infinite]',
            )}
          />
        </Tip>
        <div
          className={cn(
            `absolute left-[calc(100%-2px)] top-0 flex h-[1.125rem] min-w-[1.125rem] items-center justify-center gap-0.5 rounded-full bg-muted-foreground px-1.5`,
            isAnimating && 'bg-destructive',
          )}
        >
          <Span
            className={cn(`shrink-0 grow-0 font-medium leading-none`)}
            size={'xxs'}
            variant={`primaryForeground`}
            text={queueCount}
          />
        </div>
      </div>
    </NavLink>
  )
}
